// Generated by `npm --prefix converter-site run generate`. Do not edit.
// Sources: sushi-config.yaml, git rev-parse --short HEAD, GUIDE_BASE_URL.

/** What this bundle was built from, and where the guide it links to lives. */
export interface Provenance {
  /** The `version` in `sushi-config.yaml`. */
  readonly guideVersion: string;
  /** The short commit this bundle was built from, or `unknown`. */
  readonly commit: string;
  /** The guide root every relative guide href is resolved against. */
  readonly guideBaseUrl: string;
}

export const PROVENANCE: Provenance = {
  guideVersion: "0.1.0",
  commit: "361566d",
  guideBaseUrl: "http://hl7.org/fhir/uv/openehr-data-type-mapping/",
};
